import FormGroup from '@maison/components/form/FormGroup.vue';
import MarketingConsents from '@phoenix/components/form/MarketingConsents.vue';
import RadioListField from '@maison/components/form/fields/RadioListField.vue';

export default {
  components: {
    FormGroup,
    MarketingConsents,
    RadioListField,
  },

  props: {
    consentData: {
      type: Object,
      required: true,
    },
  },

  emits: ['update', 'update-marketing-consents'],

  computed: {
    value: {
      get() {
        return this.consentData.value;
      },
      set(value) {
        this.$emit('update', value);
      },
    },

    marketingConsentsValue: {
      get() {
        return this.consentData.marketingConsents ?? [];
      },
      set(value) {
        this.$emit('update-marketing-consents', value);
      },
    },

    marketingConsentsField() {
      const isDisabled = this.consentData.value !== 'true';

      return {
        id: `${this.consentData.id}MarketingConsents`,
        name: `${this.consentData.name}MarketingConsents`,
        type: 'checkboxList',
        disabled: isDisabled,
      };
    },
  },
};
